import React from 'react'
import Modal from './Modal.jsx'
import { useAuth } from '../lib/auth.jsx'

export default function AuthModal({ open, mode = 'login', onClose }) {
  const auth = useAuth()
  const [tab, setTab] = React.useState(mode)
  const [handle, setHandle] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [error, setError] = React.useState('')
  const [submitting, setSubmitting] = React.useState(false)

  React.useEffect(() => {
    setTab(mode)
    setError('')
  }, [mode, open])

  async function onSubmit(e) {
    e.preventDefault()
    setError('')
    setSubmitting(true)
    try {
      if (tab === 'login') {
        await auth.login(email, password)
      } else {
        await auth.register(handle, email, password)
      }
      onClose()
    } catch (err) {
      setError(err.message || 'Something went wrong.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal open={open} title={tab === 'login' ? 'Login' : 'Create account'} onClose={onClose}>
      <div className="flex gap-2 mb-4">
        <button
          type="button"
          onClick={() => setTab('login')}
          className={`flex-1 rounded-lg border px-3 py-2 text-sm ${tab === 'login' ? 'border-white/25 bg-white/10' : 'border-white/10 bg-black/20 text-white/70 hover:text-white'}`}
        >
          Login
        </button>
        <button
          type="button"
          onClick={() => setTab('register')}
          className={`flex-1 rounded-lg border px-3 py-2 text-sm ${tab === 'register' ? 'border-white/25 bg-white/10' : 'border-white/10 bg-black/20 text-white/70 hover:text-white'}`}
        >
          Register
        </button>
      </div>

      <form onSubmit={onSubmit} className="space-y-3">
        {tab === 'register' && (
          <div>
            <label className="block text-xs text-white/60 mb-1">Handle</label>
            <input
              value={handle}
              onChange={(e) => setHandle(e.target.value)}
              className="w-full rounded-lg border border-white/10 bg-black/20 px-3 py-2 outline-none focus:border-white/25"
              placeholder="Inked"
              required
              minLength={3}
              maxLength={24}
            />
          </div>
        )}

        <div>
          <label className="block text-xs text-white/60 mb-1">Email</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-lg border border-white/10 bg-black/20 px-3 py-2 outline-none focus:border-white/25"
            placeholder="you@example.com"
            type="email"
            required
          />
        </div>

        <div>
          <label className="block text-xs text-white/60 mb-1">Password</label>
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-lg border border-white/10 bg-black/20 px-3 py-2 outline-none focus:border-white/25"
            placeholder="••••••••"
            type="password"
            required
            minLength={8}
          />
          <div className="mt-1 text-[11px] text-white/40">Minimum 8 characters.</div>
        </div>

        {error && <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-200">{error}</div>}

        <button
          type="submit"
          disabled={submitting}
          className="w-full rounded-lg border border-white/15 bg-white/10 px-3 py-2 text-sm hover:bg-white/15 disabled:opacity-50"
        >
          {submitting ? 'Working...' : tab === 'login' ? 'Login' : 'Create account'}
        </button>

        <div className="text-[11px] text-white/40">
          By continuing you agree to the Terms and Privacy Policy configured for your deployment.
        </div>
      </form>
    </Modal>
  )
}
